/* import React from "react";

interface ButtonProps {
  title: string;
}

const Button: React.FC<ButtonProps> = ({ title }) => {
  return (
    <button className="button bg-blue text-white hover:bg-blue-light transition duration-300">
      {title}
    </button>
  );
};

export default Button;
 */

import { ButtonHTMLAttributes, ReactNode } from 'react';
import { Slot } from '@radix-ui/react-slot';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  children?: ReactNode;
  asChild?: boolean;
}

const Button = ({ title, children, asChild,...props }: ButtonProps) => {
  if (asChild) {
    return <Slot {...props}>{children}</Slot>;
  }

  return (
    <button className="button" {...props}>
      {title}
    </button>
  );
};

export default Button;